import React from "react";
import { format } from "date-fns";
import { cn } from "@/lib/utils";
import Event from "./Event";

interface DayCellProps {
  day: Date;
  events: any[];
  isCurrentMonth: boolean;
  isCurrentDay: boolean;
  view: string;
  onEventClick?: (event: any) => void;
}

const DayCell: React.FC<DayCellProps> = ({
  day,
  events,
  isCurrentMonth,
  isCurrentDay,
  view,
  onEventClick,
}) => {
  const dayNumber = format(day, "d");
  const maxEventsToShow = view === "month" ? 3 : 8;
  const hasMoreEvents = events.length > maxEventsToShow;
  const visibleEvents = events.slice(0, maxEventsToShow);

  return (
    <div
      className={cn(
        "min-h-[100px] overflow-hidden border p-1",
        !isCurrentMonth && "bg-gray-50 text-gray-400",
        isCurrentDay && "bg-blue-50"
      )}
    >
      <div className="mb-1 text-right">
        <span
          className={cn(
            "inline-block h-6 w-6 text-center",
            isCurrentDay && "rounded-full bg-blue-500 text-white"
          )}
        >
          {dayNumber}
        </span>
      </div>
      <div className="max-h-[80px] overflow-y-auto">
        {visibleEvents.map((event) => (
          <Event key={event.id} event={event} onClick={() => onEventClick && onEventClick(event)} />
        ))}
        {hasMoreEvents && (
          <div className="mt-1 text-center text-xs text-gray-500">
            +{events.length - maxEventsToShow} more
          </div>
        )}
      </div>
    </div>
  );
};

export default DayCell;
